// Single source for the copyright/trade-secret notice shown in App.js, ExternalApp.js and
// AuthGate.js -- one string so the wording can't drift between the three places it's rendered.
export const COPYRIGHT_NOTICE =
  '© 2026 Manatron, Inc. All rights reserved. Pulse by Aumentum is proprietary software ' +
  'and a trade secret of Manatron, Inc. Unauthorized copying, use or distribution is prohibited.';
